import { createEvent } from '@cobuildlab/react-simple-state';

export const OnItineraryReservedCount = createEvent<number>();
export const OnItineraryReservedCountError = createEvent();